/**
 * @file        src/api/siteSettings.js
 * @description Public read of the configured company/office address managed in
 *              the admin app. Backed by GET /api/v1/site-settings (single-row
 *              site_settings). One source of truth for invoices, vouchers, print
 *              modals and legal pages. Mirrors api/testimonials.js. Ported from
 *              the neon build (CR A4) so Beyond's Contact page can show the same
 *              admin-editable address neon already does.
 * @author      Kinetika Labs
 * @created     2026-08-04
 * @changelog
 *   - 2026-08-04 Claude — Ported from neon, unchanged.
 */
import { get } from './client.js';

/** The configured company info (address, city, phone, …). Returns an object. */
export async function fetchCompanyInfo() {
  const data = await get('/site-settings');
  return data?.data || data || {};
}
